export const formsUrl = (reportId?: string) => {
	if (!reportId) return window.location.origin.replace("https://", "https://forms.");
	return `${window.location.origin.replace("https://", "https://forms.")}/report/${reportId}`;
};
